var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnnouncementIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.33333C10.81 3.33333 3.33331 10.81 3.33331 20C3.33331 29.19 10.81 36.6667 20 36.6667C22.4433 36.6667 24.935 36.0483 27.4033 34.8267L25.9283 31.8383C23.9216 32.83 21.9266 33.3333 20 33.3333C12.6483 33.3333 6.66665 27.3517 6.66665 20C6.66665 12.6483 12.6483 6.66666 20 6.66666C27.3516 6.66666 33.3333 12.6483 33.3333 20V21.6667C33.3333 22.82 32.8116 25 30.8333 25C28.5066 25 28.3433 21.9683 28.3333 21.6667V13.3333H25V13.375C23.5654 12.2732 21.8088 11.6731 20 11.6667C15.405 11.6667 11.6666 15.405 11.6666 20C11.6666 24.595 15.405 28.3333 20 28.3333C22.4166 28.3333 24.58 27.2817 26.1033 25.6317C26.9766 27.115 28.45 28.3333 30.8333 28.3333C34.6216 28.3333 36.6666 24.8983 36.6666 21.6667V20C36.6666 10.81 29.19 3.33333 20 3.33333ZM20 25C17.2433 25 15 22.7567 15 20C15 17.2433 17.2433 15 20 15C22.7566 15 25 17.2433 25 20C25 22.7567 22.7566 25 20 25Z",
    fill: "#262626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementIcon);
export default __webpack_public_path__ + "static/media/announcement-icon.20c5a2d1c7699077ae23b6afd0e5e892.svg";
export { ForwardRef as ReactComponent };